<template>
  <div class="mastery-container">
    <HeaderContainer pageName="mastery" @handleHeadLink="handleHeadLink">
      <div slot="linkbtn">测评记录<i class="el-icon-arrow-right" /></div>
    </HeaderContainer>
    <main class="container_body">
      <div class="content-wrapper por_container">
        <ContainerBodyHead>
          <div slot="introduce">
            <p>专精特新中小企业实现专业化、精细化、特色化发展，创新能力强、质量效益好，是优质中小企业的中坚力量。</p>
            <p>参评四川省优质中小企业，应在四川省内工商注册登记、具有独立法人资格，符合《中小企业划型标准规定》，企业未被列入经营异常名录或严重失信主体名单，提供的产品（服务）不属于国家禁止、限制或淘汰类，同时近三年未发生重大安全（含网络安全、数据安全）、质量、环境污染等事故以及偷漏税等违法违规行为。</p>
          </div>
        </ContainerBodyHead>
        <div class="count u-text-center u-font-16">已累计为<span class="t-b">{{ reviewCount }}</span>家企业提供测评与综合解决方案</div>
        <div class="form-container">
          <div class="tag">
            <TagTitle title="企业基本信息" />
          </div>
          <ContainerBodyForm ref="ContainerBodyForm" :formData="formData" :industryList="industryTree" :provinceTree="provinceTree" :cityTree="cityTree" :districtTree="districtTree" :_disabled="disabled" :entNameDisabled="entNameDisabled"
            @handleSelect="handleSelect" @clearEntName="clearEntName" @handleProvince="handleProvince" @handleCity="handleCity" @handleIndustry="handleIndustry" @toEvaluation="toEvaluation" />
        </div>
        <ContainerBodyFoot pageName="mastery" @handleValidate="handleValidate">
          <p slot="content">“专精特新”是国家为引导中小企业走专业化、精细化、特色化、新颖化发展之路,增强自主创新能力和核心竞争力，不断提高中小企业发展质量和水平而实施的重大工程。2021年至2025年中央财政累计安排100亿元以上奖补资金支持中小企业专精特新发展，进一步激发中小企业活力和发展动力，推动中小企业转型升级。</p>
          <div class="gradient" slot="gradient">
            <div class="gradient-title-img">
              <img src="@/assets/images/grandient_title-1.png" alt="">
            </div>
            <div class="u-relative">
              <div class="gradient-img">
                <img src="@/assets/images/gradient.png" alt="gradient" />
              </div>
              <div v-for="item in navGroup" :key="item.id">
                <template v-if="item.isUse">
                  <router-link class="link" :class="item.value" :to="'/' + item.value" disabled>{{ item.linkText }}</router-link>
                </template>
                <template v-else>
                  <span class="link" :class="item.value">{{ item.linkText }}</span>
                </template>
              </div>
            </div>
          </div>
        </ContainerBodyFoot>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import applicationList from '@/assets/contants/applicationList';
import { reqEnterpriseInfo, reqEnterpriseList } from '@/api/dictAPI';
import { reqReviewCount } from '@/api/userAPI';
export default {
  data() {
    return {
      navGroup: applicationList.qualityNavGroup,
      formData: {
        entName: '', // 企业名称
        regDate: '', // 注册日期
        uniteCode: '', // 社信代码
        corporate: '', // 法定代表人
        regProvince: '', // 省份
        provinceCode: '',
        regCity: '', // 州市
        cityCode: '',
        regDistrict: '', // 区县
        districtCode: '',
        industry: '', // 所属行业
        industryCode: '',
        regAddress: '', // 注册地址
        contactName: '', // 申报联系人
        contactMobile: '', // 联系电话
      },
      reviewType: 6,
      reviewCount: 0,
      provinceTree: [],
      cityTree: [],
      districtTree: [],
      industryTree: [],
      disabled: false,
      entNameDisabled: false,
    };
  },
  computed: {
    ...mapState('pageOptions', ['districtList', 'industryList']),
    ...mapState('personOptions', ['userEnterpriseInfo']),
    ...mapGetters('personOptions', ['_isLogin']),
  },
  created () {
    this.init();
  },
  methods: {
    // 初始化数据
    init() {
      this.initUserEnterpriseInfo();
      this.initReviewCount();
      this.districtList && this.districtList.length ? this.initDistrictList(this.districtList) : '';
      this.industryList && this.industryList.length ? this.initIndustryList(this.industryList) : '';
    },
    // 初始化已登录用户企业信息
    initUserEnterpriseInfo() {
      if (!this._isLogin) return;
      this.formData.entName = this.userEnterpriseInfo.entName;
      this.querySearch(this.formData.entName);
    },
    // 初始化省级下拉框
    initDistrictList(districtList) {
      this.provinceTree = districtList;
    },
    initIndustryList(industryList) {
      this.industryTree = industryList;
    },
    // 初始化测评总数量
    initReviewCount() {
      reqReviewCount(this.reviewType).then(resp => {
        if (resp.result) {
          this.reviewCount = resp.data + 500;
        }
      });
    },
    async querySearch(queryString) {
      const resp = await reqEnterpriseList(queryString);
      if (resp.result && resp.data && resp.data.length) {
        this.handleSelect(queryString);
      }
    },
    clearEntName() {
      this.formData.entName = '';
    },
    handleHeadLink() {
      this.$router.push(`/history?reviewType=${this.reviewType}`);
    },
    // 选中企业
    handleSelect(name) {
      reqEnterpriseInfo(name).then(resp => {
        if(resp.result) {
          const { data: enterpriseInfo } = resp;
          Object.keys(this.formData).forEach(key => {
            if (enterpriseInfo.hasOwnProperty(key)) {
              this.formData[key] = enterpriseInfo[key];
            }
          });
          if (['', null, undefined].indexOf(this.formData.industryCode) === -1) {
            this.formData.industryCode = this.formData.industryCode.slice(0, 3)
          }
          if (['', null, undefined].indexOf(this.formData.districtCode) === -1) {
            this.formData.provinceCode = this.formData.districtCode.slice(0, 2);
            this.formData.cityCode = this.formData.districtCode.slice(0, 4);
            this.formData.districtCode = this.formData.districtCode.length > 4 ? this.formData.districtCode : '';
          }
          this.formData.industry = this.findIndustryName(this.industryList, this.formData.industryCode);
          this.disabled = true;
          this.entNameDisabled = this._isLogin ? true : false;
        }
      })
    },
    // 选择地区
    handleProvince(code) {
      const result = this.provinceTree.filter(item => item.districtCode === code);
      this.cityTree = result[0].child;
    },
    handleCity(code) {
      const result = this.cityTree.filter(item => item.districtCode === code);
      this.districtTree = result[0].child;
    },
    handleIndustry(industryCode = '') {
      this.formData.industry = industryCode;
    },
    // 验证表单选项
    handleValidate() {
      this.$refs.ContainerBodyForm.submitForm();
    },
    // 前往测评
    toEvaluation() {
      this.$store.commit('personOptions/SET_ENTERPRISE_INFO', this.formData);
      this.$router.push('/mastery_evaluation');
    },
    findIndustryCode(arr, target) {
      for (let i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i].child)) {
          const result = this.findIndustryCode(arr[i].child, target);
          if (result !== '') {
            return result;
          }
        } else if (arr[i].industryName === target) {
          return arr[i].industryCode;
        }
      }
      return '';
    },
    findIndustryName(arr, target) {
      for (let i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i].child)) {
          const result = this.findIndustryName(arr[i].child, target);
          if (result !== '') {
            return result;
          }
        } else if (arr[i].industryCode === target) {
          return arr[i].industryName;
        }
      }
      return '';
    },
  },
  watch: {
    "formData.provinceCode"(newVlaue, oldValue) {
      if (['', undefined, null].indexOf(newVlaue) === -1) {
        const result = this.provinceTree.find(item => item.districtCode === newVlaue);
        this.cityTree = result ? result.child : [];
        this.formData.regProvince = result ? result.districtName : '';
      }
    },
    "formData.cityCode"(newVlaue, oldValue) {
      if (['', undefined, null].indexOf(newVlaue) === -1) {
        const result = this.cityTree.find(item => item.districtCode === newVlaue);
        this.districtTree = result ? result.child : [];
        this.formData.regCity = result ? result.districtName : '';
      }
    },
    "formData.districtCode"(newVlaue, oldValue) {
      if (['', undefined, null].indexOf(newVlaue) === -1) {
        const result = this.districtTree.find(item => item.districtCode === newVlaue);
        this.formData.regDistrict = result ? result.districtName : '';
      }
    },
    "industryList"(newVlaue, oldValue) {
      newVlaue && newVlaue.length ? this.initIndustryList(newVlaue) : '';
    },
    "districtList"(newVlaue, oldValue) {
      newVlaue && newVlaue.length ? this.initDistrictList(newVlaue) : '';
    },
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  padding: 32px 0 64px;

  .count {
    color: #909399;
    margin-bottom: 64px;

    .t-b {
      margin: 0 8px;
    }
  }

  .form-container {
    padding: 32px 32px 10px;
    background-color: #fff;
    border: 1px solid #bfbfbf;
    border-radius: 8px;
    position: relative;
    z-index: 100;

    .tag {
      position: absolute;
      left: 22px;
      top: -16px;
      z-index: 101;
    }
  }

  .gradient {
    display: flex;
    flex-direction: column;
    align-items: center;

    &-title-img {
      width: 300px;
      margin-bottom: 10px;
    }

    &-img {
      width: 320px;
    }

    .link {
      color: #2c75f8;
      font-size: 16px;
      font-weight: bold;
      position: absolute;

      &.champion {
        right: -48px;
        top: 18px;
      }

      &.giant {
        right: -136px;
        top: 82px;
      }

      &.mastery {
        right: -194px;
        top: 148px;
      }

      &.innovative {
        right: -222px;
        top: 216px;
      }

      &::before {
        content: "";
        width: 100px;
        height: 0;
        border-bottom: 1px dashed #2c75f8;
        position: absolute;
        left: -120px;
        top: 50%;
        transform: translateY(-50%);
      }

      &::after {
        content: "";
        width: 10px;
        height: 10px;
        background-color: #2c75f8;
        border-radius: 50%;
        position: absolute;
        left: -20px;
        top: 50%;
        transform: translateY(-50%);
      }

      &.router-link-exact-active {
        color: #ff0000;

        &::before {
          border-bottom-color: #ff0000;
        }

        &::after {
          background-color: #ff0000;
        }
      }
    }
  }
}
</style>